class EditSampleModalController {
    static $inject = ['apiFactory', 'stToast', '$q'];

    /**
     * @param {ApiFactory} apiFactory
     * @param {StToast} toast
     * @param {ng.IQService} $q
     */
    constructor(apiFactory, toast, $q) {
        this.apiFactory = apiFactory;
        this.toast = toast;
        this.$q = $q;

        this.samplesApi = this.apiFactory.create('api/v1/samples');
        this.sampleTypeApi = this.apiFactory.create('api/v1/sample-types');

        /** @type {Sample} */
        this.sample = undefined;

        /** @type {Sample[]} */
        this.samples = [];

        /** @type {SampleType[]} */
        this.sample_types = [];
    }

    $onInit() {
        Object.assign(this, this.resolve); // reference resolved objects on local 'this'

        // load supporting data for dropdowns, etc.
        this.$q.all([
                this.samplesApi.all(),
                this.sampleTypeApi.all()
            ])
            .then(([samples, sampleTypes]) => {
                this.samples = samples;
                this.sample_types = sampleTypes;
            })
            .catch(this.toast.errorHandler);
    }

    /** @param {string} sample_name */
    sampleNameExists = (sample_name) => {
        // st-unique directive expects a promise
        return this.$q.resolve(this.samples.some(c => c.sample_id !== this.sample.sample_id && c.sample_name.toLowerCase() === sample_name.toLowerCase()));
    };

    save = () => {
        this.samplesApi.update(this.sample.sample_id, this.sample)
            .then(updatedSample => {
                this.close({ $value: updatedSample });
            })
            .catch(this.toast.errorHandler);
    };
}

angular
    .module('app')
    .component('editSampleModal',
        {
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            },
            templateUrl: 'src/app/samples/modals/editSampleModal.html',
            controller: EditSampleModalController
        });